import actionTypes from '../constants/action-types';
import DEFAULT_OPTIONS from '../constants/default-options';

const updateAtomicCSS = (stylesString, options = DEFAULT_OPTIONS) => ({
  type: actionTypes.UPDATE_ATOMIC_CSS,
  payload: {
    stylesString,
    options,
  },
});

export default updateAtomicCSS;
